<div>Spent Time - {{ timer$ | async }}</div>
